export default __webpack_public_path__ + "static/4-drop-shadow-72e87a368bccf9f7fa756f8834ef80aa.png";